<template>
  <div class="inner-content">
    <div class="b-gray-1 filter-wrp m-t-md m-b-20">
      <div class="clearfix">
        <div class="gray-4 pull-left f1">我的收藏：</div>
      </div>
    </div>
    <div class="clearfix m-t-md c-3-1-wrp">
      <div class="c-3-1 m-b-md b-gray-1 hp-item-6" v-for="f in favorList" @click="goToCase(f.id)">
        {{/** use background for image */}}
        <div class="clearfix m-a img-c-div h-44" v-bind:style="{backgroundImage: 'url(' + f.coverImgUrl + ')'}">
        </div>
        <div class="collect-heat text-center" v-if="f.isFavored" @click.stop="unfavor(f)">
          <i class="fa fa-heart heart-pink" />
          <span class="gray-1 text-medium">{{f.favorNum}}</span>
        </div>
        <div class="collect-heat text-center"  v-if="!f.isFavored">
          <i class="fa fa-heart-o" />
          <span class="gray-1 text-medium">{{f.favorNum}}</span>
        </div>
        <div class="m-a b-gray-1 p-a h-p-item-c">
          <!--<div class="text-price m-b-md">¥{{f.sellPrice/100}}</div>-->
          <div class="text-price m-b-15"><span class="f-6"><span>{{f.shopInfo && f.shopInfo.cityName ? f.shopInfo && f.shopInfo.cityName : '北京'}}</span>｜{{f.title}}</span>
            <span class="f-7" v-if="(f.shopInfo&&f.shopInfo.name) !== null && (f.shopInfo&&f.shopInfo.name) !==undefined">－{{f.shopInfo && f.shopInfo.name}}</span>
          </div>
          <div class="gray-1 text-small">
            <!--<div class="text-elli">{{f.title}}</div>-->
            <div class="text-elli">{{f.description}}</div>
          </div>
        </div>
      </div>
    </div>
    <pagination :pagination="pagination" :callback="loadData" :options="paginationOptions"></pagination>
  </div>
</template>
<script>
import pagination from '../reusable/Pagination';
import { mixinPager } from '../reusable/pager';
import apiHelper from '../service/apiHelper';

const vm = {
  name: 'Collect',
  mainService: apiHelper,
  service: 'getFavorList',
  dataKey: 'favorList',
  data() {
    return {
      condition: {
        offset: 0,
        count: 10,
      },
      favorList: [],
    };
  },
  components: {
    pagination,
  },
  created() {
    this.pagination.per_page = 10;
  },
  methods: {
    goToCase(id) {
      this.$router.push({ name: 'CaseDetail', params: { id } });
    },
    unfavor(caseInfo) {
      apiHelper.unFavorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', false);
      });
    },
  },
};

mixinPager(vm);

export default vm;
</script>
<style>
  .filter-wrp {
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f8f8f8;
    font-size: 14px;
    line-height: 44px;
    vertical-align: middle;
    color: #252525;
    font-weight: 300;
  }
.f1 {
  font-size: 16px;
}
.collect-heat {
  height: 25px;
  width: 60px;
  background-color: rgba(255,255,255,0.7);
  line-height: 25px;
  float: right;
  margin-top: -40px;
  margin-right: 15px;
  cursor: pointer;
}
.m-b-15 {
  /*margin-top: 10px;*/
  margin-bottom: 15px;
}
.f-6 {
  font-size: 16px;
  color: #525252;
  font-weight: bold;
}
.f-7{
  font-size: 16px;
  color: #787878;
  font-weight: lighter;
}
.v-a {
  vertical-align:middle;
}

</style>



// WEBPACK FOOTER //
// Collect.vue?4d4e8eae